import { useTranslation } from 'react-i18next';
import WithTooltip from '../Fundamentals/Tooltip/WithTooltip';
import { orEmpty, withSek } from './worksheetFormatters';

interface BilledImpactLineProps {
    amount: number;
    hasQuantity: boolean;
    className: string;
    textClassName: string;
}

const BilledImpactLine = ({ amount, hasQuantity, className, textClassName }: BilledImpactLineProps) => {
    const { t } = useTranslation();

    return (
        <WithTooltip content={t('priceSimulation.billedImpactTooltip')} className={className} focusable>
            <span className={`${textClassName} text-secondary`}>{t('priceSimulation.billedImpact', { amount: orEmpty(hasQuantity, withSek(amount)) })}</span>
        </WithTooltip>
    );
};

export default BilledImpactLine;
